import { NAVY } from './palette';

export interface BarraItem {
  id: string;
  label: string;
  sublabel?: string | null;
  valor: number;
  valorLabel: string;
  color?: string;
}

/**
 * Ranked magnitude, one series. No legend — the title names the measure — and a
 * direct label on every bar, because the numbers are the point.
 */
export function BarrasHorizontais({ items }: { items: BarraItem[] }) {
  const max = Math.max(1, ...items.map((i) => i.valor));

  return (
    <ul className="flex flex-col">
      {items.map((item, index) => (
        <li key={item.id} className={index > 0 ? 'border-t border-conduril-border pt-3' : ''}>
          <div className={`flex items-baseline justify-between gap-3 ${index > 0 ? '' : ''}`}>
            <span className="min-w-0 truncate text-[13px] font-medium text-conduril-ink">
              {item.label}
              {item.sublabel && (
                <span className="num ml-2 text-[10px] tracking-wide text-conduril-muted">
                  {item.sublabel}
                </span>
              )}
            </span>
            <span className="num shrink-0 text-[13px] font-semibold text-conduril">
              {item.valorLabel}
            </span>
          </div>
          <div className="mb-3 mt-2 h-1.5 overflow-hidden rounded-full bg-conduril-tint">
            <div
              className="h-full rounded-full transition-[width] duration-300"
              style={{
                width: `${Math.max(2, (item.valor / max) * 100)}%`,
                background: item.color ?? NAVY,
              }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
}
